import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TelegramIcon from "@mui/icons-material/Telegram";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
    Button,
    Card,
    CardContent,
    Chip,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    styled,
    tableCellClasses,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BotMessageType, BotStatus, ERoles, TemplateStatus, TemplateTypes } from "../../../config";
import useAuth from "../../../hooks/useAuth";
import { getAllVerifiedBotsThunk } from "../../../redux/botManagement/botManagementThunk";
import {
    clearErrorMessagesForTemplates,
    setSelectedBotDetails,
    setShowAddTemplateForm,
} from "../../../redux/templateManagement/templateManagementSlice";
import { getAllTemplatesByFilterThunk, getAllTemplatesByPageSize } from "../../../redux/templateManagement/templateManagementThunk";
import { apiGatewayAxiosInstance } from "../../../utils/axios";
import { calculateTime } from "../../../utils/calculateTime";
import { formatDataToShowInUI } from "../../../utils/formatDataToShowInUI";
import TablePaginationShowPage from "../../../utils/tablePagination";
import AlertMessageComponent from "../../components/AlertMessageComponent";
import FetchingSpinner from "../../components/FetchingSpinner";
import NoRecords from "../../components/NoRecords";
import StyledMenu from "../../tables/StyledMenu";
import DeleteTemplateConformationModel from "./DeleteTemplateConformationModel";
import FilterAllTemplateModel from "./FilterTemplateModel";
import TestTemplateModel from "./addTemplate/TestTemplateModel";
import SuccessMessageComponent from "../../components/SuccessMessageComponent";
import RemoveFromQueueIcon from "@mui/icons-material/RemoveFromQueue";
import SearchableDropdown from "../../mis/SearchableDropdown";
import RefreshButton from "../../../utils/refreshButton";
import SearchableBotDropdown from "../../mis/SearchableBotDropdown";
import SearchableBotDropdownForTemplate from "../../mis/SearchableBotDropdownForTemplate";

// import CustomTablePagination from "../../../utils/tablePagination";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 24,
        backgroundColor: theme.palette.common.lightBlue,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 22,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },

    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const ListTemplates = ({ searchParams, setSearchParams, handleViewDetailsChange, selectedBotname, setSelectedBotName }) => {
    const state = useSelector(state => state.templateManagementSlice);
    const botState = useSelector(state => state.botManagementSlice);
    const dispatch = useDispatch();
    const [deleteTemplateModel, setDeleteTemplateModel] = useState(false);
    const [testTemplate, setTestTemplate] = useState(false);
    const [templateData, setTemplateData] = useState({});
    const [templateBotDetails, setTemplateBotDetails] = useState({});

    const { user } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    const [selectedBotId, setSelectedBotId] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = anchorEl?.id.split("@")[1];
    const [errorResponse, setErrorResponse] = useState("");
    const [openFilter, setOpenFilter] = React.useState(false);
    const [operationStatus, setOperationStatus] = useState({
        success: false,
        failed: false,
        message: "",
    });
    const [reload, setReload] = useState(false);
    const [activeReseller, setActiveReseller] = useState([]);
    const [selectedReseller, setSelectedReseller] = useState("");
    const [selectedOrganization, setSelectedOrganization] = useState("");
    const [availableOrganization, setAvailableOrganization] = useState([]);

    const handleClickOpenFilterModel = () => {
        setOpenFilter(true);
    };

    const handleCloseFilterModel = () => {
        setOpenFilter(false);
    };
    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const reloadList = () => {
        setReload(!reload);
    };

    const getActiveReseller = async () => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/user_management/reseller/get-active-reseller`);
            setActiveReseller(response.data.data);
            setCurrentPage(0);
            setPageSize(10);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    };

    const setSelectedResellerAndGetOrgForSelectedReseller = async e => {
        try {
            let value = "";
            if (user?.roleName === ERoles.SUPER_ADMIN) {
                value = e.target.value;
            }
            const registryId = value || user?.registryId;
            const isAll = registryId === "All";
            setSelectedReseller(isAll ? "" : registryId);
            setSelectedOrganization(isAll ? "All" : "");
            // setSelectedBot(isAll ? "All" : "");
            dispatch(setSelectedBotDetails({}));

            if (!isAll) {
                const { data } = await apiGatewayAxiosInstance.get(`/user_management/organization/get-all-active-org-by-registryId`, {
                    params: { registryId },
                });
                setAvailableOrganization(data.data);
            } else {
                setAvailableOrganization([]);
            }
            setCurrentPage(0);
            setPageSize(10);
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    };

    const onClickAddNewTemplate = () => {
        dispatch(setShowAddTemplateForm(true));
    };

    const getTemplateDetailsFromProvider = async ({ templateData, isEditable, isSubmitForApproval }) => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/bot_management/template/get-template-detail-by-templateId`, {
                params: { templateId: templateData._id, botId: templateData.botId },
            });

            if (response.status === 200) {
                handleViewDetailsChange({
                    templateData: response.data,
                    val: isEditable,
                    isSubmitForApproval: isSubmitForApproval || false,
                });
            } else {
                throw new Error(response);
            }
        } catch (error) {
            let errorMessage = "Failed to get template details.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    };

    const handelDeprecate = async id => {
        setIsLoading(true);
        const response = await apiGatewayAxiosInstance.post(`/bot_management/template/deprecate-template?templateId=${id}`);

        setOperationStatus({
            message: "Template Deprecated Successfully.",
            success: true,
            failed: false,
        });

        dispatch(getAllVerifiedBotsThunk());
        setAnchorEl(null);
        dispatch(
            getAllTemplatesByFilterThunk({
                currentPage: currentPage + 1,
                pageSize,
                botId: state.selectedBotDetails._id,
                searchParams,
            }),
        );
        setIsLoading(false);
    };

    const onClickDeleteTemplate = async templateData => {
        setTemplateData(templateData);
        setDeleteTemplateModel(true);
        // try {
        //   const response = await apiGatewayAxiosInstance.get(`template/delete-template/${state.selectedBotDetails._id}/${templateData.templateName}`);

        //   if (response.status === 200) {
        //     dispatch(getAllVerifiedBotsThunk());
        //     if (state.selectedBotDetails) {

        //       dispatch(getAllTemplatesByPageSize({ currentPage: 1, pageSize: 10, botId: state.selectedBotDetails.config.rbmClientId }));
        //     }
        //   } else {
        //     throw new Error(response);
        //   }
        // } catch (error) {
        //   if (error.response) {
        //     setErrorResponse(error.response.data.message);
        //   } else {
        //     setErrorResponse("Server not reachable");

        //   }
        // }
    };

    const onCloseErrorMessage = ({ fieldName }) => {
        dispatch(clearErrorMessagesForTemplates({ fieldName }));
    };

    const handleClickSearch = searchParams => {
        setCurrentPage(0);
        setPageSize(10);
        setSearchParams(searchParams);
        handleCloseFilterModel();

        if (currentPage == 0) {
            getAllTemplate({ searchParams });
        }
    };

    const onChangeSelectBot = e => {
        let selecBotname = e.target.value;

        setSelectedBotName(selecBotname);
        const bot = botState.verifiedBotList.filter(botData => botData.botName === selecBotname)[0];
        dispatch(setSelectedBotDetails(bot));

        const botClientId = bot?._id;
        setSelectedBotId(botClientId);
        setCurrentPage(0);
        setPageSize(10);
    };

    const onClickTestTemplate = async templateData => {
        setTemplateData(templateData);
        const bot = botState.verifiedBotList.find(botData => botData._id === templateData.botId);
        setTemplateBotDetails(bot);
        setTestTemplate(true);
    };

    const handleCloseSuccessMessage = () => {
        setOperationStatus({ success: false, failed: false, message: "" });
    };

    const setSelectedOrganizationAndGetBotsForSelectedOrganization = async e => {
        try {
            const value = e.target.value;
            const orgId = (value === "All" ? "" : value) || user?.orgId;
            const isAll = orgId === "All";
            setSelectedOrganization(isAll ? "" : orgId);
            dispatch(setSelectedBotDetails({}));
            setCurrentPage(0);
            setPageSize(10);
        } catch (error) {
            let errorMessage = "Server not reachable.";
            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            setErrorResponse(errorMessage);
        }
    };
    const getAllTemplate = ({ searchParams }) => {
        setAnchorEl(null);
        const orgId = user?.orgId ? user?.orgId : selectedOrganization === "All" ? "" : selectedOrganization;
        const registryId = user?.registryId ?? selectedReseller;
        const botId = state.selectedBotDetails?._id;
        dispatch(
            getAllTemplatesByFilterThunk({
                currentPage: currentPage + 1,
                pageSize,
                botId: botId,
                searchParams,
                registryId: registryId,
                orgId: orgId,
            }),
        );
    };
    useEffect(() => {
        if (user?.roleName) {
            getAllTemplate({ searchParams });
        }
        // }
    }, [currentPage, pageSize, user, state?.selectedBotDetails?._id, selectedReseller, selectedOrganization, reload]);

    useEffect(() => {
        if (user?.roleName) {
            const orgId = user?.orgId ? user?.orgId : selectedOrganization == "All" ? "" : selectedOrganization;
            const registryId = user?.registryId ?? (selectedReseller == "All" ? "" : selectedReseller);
            dispatch(getAllVerifiedBotsThunk({ orgId, registryId }));
            if (user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN && activeReseller.length === 0) getActiveReseller();
            if (user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN && !selectedOrganization) setSelectedResellerAndGetOrgForSelectedReseller();
        }
    }, [selectedReseller, selectedOrganization, user?.roleName]);

    return (
        <>
            <Grid mb={4}>
                <Grid justifyContent="space-between" container spacing={6}>
                    <Grid item md={2}>
                        <Typography variant="h3" gutterBottom>
                            Templates
                        </Typography>
                    </Grid>
                </Grid>

                <Grid className="mt-2">
                    <Card className="border border-secondary-50">
                        <CardContent sx={{ padding: 0 }}>
                            <Grid
                                container
                                display={"flex"}
                                justifyContent={"space-between"}
                                className="text-primary align-items-center "
                                padding={5}
                            >
                                {user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
                                    <Grid item md={2}>
                                        <FormControl size="small" fullWidth>
                                            <SearchableDropdown
                                                label="Select Reseller"
                                                placeholder="Reseller"
                                                name="Active Reseller"
                                                size="small"
                                                dropDownList={[...activeReseller]}
                                                value={selectedReseller || "All"}
                                                handleChange={setSelectedResellerAndGetOrgForSelectedReseller}
                                                valueKey="_id"
                                                dropDownValueKey="resellerName"
                                            />
                                        </FormControl>
                                    </Grid>
                                )}
                                {(user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN || user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN) && (
                                    <Grid item md={2}>
                                        <FormControl size="small" fullWidth>
                                            <SearchableDropdown
                                                label="Select Organization"
                                                placeholder="Organization"
                                                name="Active Organization"
                                                size="small"
                                                disabled={user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN && !selectedReseller}
                                                dropDownList={[...availableOrganization]}
                                                value={selectedOrganization || "All"}
                                                handleChange={setSelectedOrganizationAndGetBotsForSelectedOrganization}
                                                valueKey="_id"
                                                dropDownValueKey="orgName"
                                            />
                                        </FormControl>
                                    </Grid>
                                )}
                                <Grid item md={4.5}>
                                    <FormControl size="small" fullWidth>
                                        <SearchableBotDropdownForTemplate
                                            value={state.selectedBotDetails?.botName || "All"}
                                            onChange={onChangeSelectBot}
                                            botList={botState.verifiedBotList || []}
                                            user={user}
                                            label="Select Bot"
                                            labelId="botType-label"
                                            id="botType-label"
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item md={3} justifyContent={"end"} display={"flex"}>
                                    <Grid>
                                        <RefreshButton loading={state.controls.isGetAllTemplatesLoading} onClick={reloadList} />
                                    </Grid>

                                    {user &&
                                        (user.roleName.toLowerCase() === ERoles.ORG_ADMIN ||
                                            user.roleName.toLowerCase() === ERoles.RESELLER_ADMIN) && (
                                            <Button
                                                variant="contained"
                                                onClick={onClickAddNewTemplate}
                                                sx={{ marginBottom: "10px", marginLeft: "10px" }}
                                            >
                                                Add New Template
                                            </Button>
                                        )}

                                    <Grid paddingLeft={1}>
                                        {/* {state.selectedBotDetails.botName && state.selectedBotDetails.botName !== "" && ( */}
                                        <Button sx={{ marginRight: "10px" }} variant="contained" onClick={handleClickOpenFilterModel}>
                                            Filter
                                        </Button>
                                        {/* )} */}
                                    </Grid>
                                </Grid>
                            </Grid>
                            {state.controls.isGetAllTemplatesLoading || isLoading ? (
                                <FetchingSpinner />
                            ) : state.templateListByPageSize.length > 0 ? (
                                <TableContainer component={Paper} className="table-container" sx={{ maxHeight: "60vh" }}>
                                    <Table stickyHeader aria-label="simple table">
                                        <TableHead className="p-3 mb-2 row">
                                            <TableRow>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    Sr No
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="left">
                                                    Template Name
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="left">
                                                    Bot Name
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="left">
                                                    Template Type
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    Created At
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    Status
                                                </StyledTableCell>

                                                <StyledTableCell className="tableHeaderFont" align="left">
                                                    Actions
                                                </StyledTableCell>
                                                {/* )} */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {state.templateListByPageSize.length > 0 &&
                                                state.templateListByPageSize?.map((template, index) => (
                                                    <StyledTableRow key={index}>
                                                        <StyledTableCell className="tableContentFont" align="center">
                                                            <b>{currentPage * pageSize + index + 1}</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell className="tableContentFont" align="left">
                                                            {template.templateName}
                                                        </StyledTableCell>
                                                        <StyledTableCell className="tableContentFont" align="left">
                                                            {
                                                                botState?.verifiedBotList?.find(bot => {
                                                                    return bot?._id === template?.botId;
                                                                })?.botName
                                                            }
                                                        </StyledTableCell>
                                                        <StyledTableCell className="tableContentFont" align="left">
                                                            {template?.templateType === TemplateTypes.TEXT_MESSAGE_WITH_MEDIA
                                                                ? "Text + PDF"
                                                                : formatDataToShowInUI(template?.templateType)}
                                                        </StyledTableCell>
                                                        <StyledTableCell className="tableContentFont" align="center">
                                                            {template.createdAt ? calculateTime(template.createdAt) : "-"}
                                                        </StyledTableCell>

                                                        <StyledTableCell className="tableContentFont" align="center">
                                                            {(() => {
                                                                if (template?.status === TemplateStatus.Pending) {
                                                                    return (
                                                                        <Typography color="orange">
                                                                            {template?.status?.replaceAll("_", " ").toUpperCase()}
                                                                        </Typography>
                                                                    );
                                                                } else if (template?.status === TemplateStatus.Approved) {
                                                                    return (
                                                                        <Typography color="green">
                                                                            {template?.status?.replaceAll("_", " ").toUpperCase()}
                                                                        </Typography>
                                                                    );
                                                                } else if (template?.status === TemplateStatus?.Rejected) {
                                                                    return (
                                                                        <Typography color="error">
                                                                            {template?.status?.replaceAll("_", " ").toUpperCase()}
                                                                        </Typography>
                                                                    );
                                                                } else if (template?.status === TemplateStatus?.CREATED) {
                                                                    return (
                                                                        <Typography color="orange">
                                                                            {template?.status?.replaceAll("_", " ").toUpperCase()}
                                                                        </Typography>
                                                                    );
                                                                } else {
                                                                    return (
                                                                        <Typography color="secondary">
                                                                            {template?.status?.replaceAll("_", " ").toUpperCase()}
                                                                        </Typography>
                                                                    );
                                                                }
                                                            })()}
                                                        </StyledTableCell>
                                                        <StyledTableCell className="tableContentFont" align="left">
                                                            <IconButton
                                                                id={`menu-button@${String(template.templateName).replaceAll("@", "")}`}
                                                                aria-controls={
                                                                    open === String(template.templateName).replaceAll("@", "")
                                                                        ? `customized-menu@${String(template.templateName).replaceAll("@", "")}`
                                                                        : undefined
                                                                }
                                                                aria-haspopup="true"
                                                                aria-expanded={
                                                                    open == String(template.templateName).replaceAll("@", "") ? "true" : undefined
                                                                }
                                                                variant="contained"
                                                                // disableElevation
                                                                onClick={handleClick}
                                                            >
                                                                <MoreVertIcon />
                                                            </IconButton>
                                                            <StyledMenu
                                                                id={`customized-menu@${String(template.templateName).replaceAll("@", "")}`}
                                                                MenuListProps={{
                                                                    "aria-labelledby": `menu-button@${String(template.templateName).replaceAll(
                                                                        "@",
                                                                        "",
                                                                    )}`,
                                                                }}
                                                                anchorEl={anchorEl}
                                                                open={open === String(template.templateName).replaceAll("@", "")}
                                                                onClose={handleClose}
                                                            >
                                                                <MenuItem
                                                                    onClick={() =>
                                                                        getTemplateDetailsFromProvider({
                                                                            templateData: template,
                                                                            isEditable: false,
                                                                        })
                                                                    }
                                                                >
                                                                    <IconButton title="view Details">
                                                                        <VisibilityIcon className="text-primary" />
                                                                    </IconButton>
                                                                    View Template
                                                                </MenuItem>

                                                                {(template?.status === TemplateStatus.Approved ||
                                                                    template?.status === TemplateStatus.Pending ||
                                                                    template?.status === TemplateStatus.CREATED) &&
                                                                    state?.selectedBotDetails?.providerDetails?.provider?.toUpperCase() !== "JIO" && (
                                                                        <MenuItem onClick={() => onClickTestTemplate(template)}>
                                                                            <IconButton title="test Details">
                                                                                <TelegramIcon className="text-primary" />
                                                                            </IconButton>
                                                                            Test Template
                                                                        </MenuItem>
                                                                    )}

                                                                {(template?.status === TemplateStatus.Approved ||
                                                                    template?.status === TemplateStatus.Pending) &&
                                                                    state?.selectedBotDetails?.providerDetails?.provider?.toUpperCase() === "JIO" && (
                                                                        <MenuItem onClick={() => onClickTestTemplate(template)}>
                                                                            <IconButton title="test Details">
                                                                                <TelegramIcon className="text-primary" />
                                                                            </IconButton>
                                                                            Test Template
                                                                        </MenuItem>
                                                                    )}

                                                                {(template?.status === TemplateStatus.Pending ||
                                                                    template?.status === TemplateStatus.Rejected) &&
                                                                    user?.roleName === ERoles.ORG_ADMIN && (
                                                                        <MenuItem
                                                                            onClick={() =>
                                                                                getTemplateDetailsFromProvider({
                                                                                    templateData: template,
                                                                                    isEditable: true,
                                                                                })
                                                                            }
                                                                        >
                                                                            <IconButton title="Update Details">
                                                                                <FormatAlignLeftIcon className="text-primary" />
                                                                            </IconButton>
                                                                            Update Template
                                                                        </MenuItem>
                                                                    )}

                                                                {(user &&
                                                                    user.roleName.toLowerCase() === ERoles.ORG_ADMIN &&
                                                                    template.status !== TemplateStatus.Approved) ||
                                                                    (template.status !== TemplateStatus.DEPRECATED && (
                                                                        <MenuItem onClick={() => onClickDeleteTemplate(template)}>
                                                                            <IconButton title="Delete Details">
                                                                                <DeleteIcon className="text-danger" />
                                                                            </IconButton>
                                                                            Delete Template
                                                                        </MenuItem>
                                                                    ))}

                                                                {template.status !== TemplateStatus.DEPRECATED && (
                                                                    <MenuItem onClick={() => handelDeprecate(template._id)}>
                                                                        <IconButton title="Deprecate">
                                                                            <RemoveFromQueueIcon className="text-primary" />
                                                                        </IconButton>
                                                                        Deprecate Template
                                                                    </MenuItem>
                                                                )}

                                                                {/* created */}
                                                                {template.status === TemplateStatus.CREATED && (
                                                                    <MenuItem
                                                                        onClick={() =>
                                                                            getTemplateDetailsFromProvider({
                                                                                templateData: template,
                                                                                isEditable: false,
                                                                                isSubmitForApproval: true,
                                                                            })
                                                                        }
                                                                    >
                                                                        <IconButton title="Submit for Approval">
                                                                            <FormatAlignLeftIcon className="text-primary" />
                                                                        </IconButton>
                                                                        Submit for Approval
                                                                    </MenuItem>
                                                                )}
                                                            </StyledMenu>
                                                            {template.status === TemplateStatus.Rejected && template.reason && (
                                                                <Tooltip
                                                                    title={
                                                                        <p
                                                                            style={{
                                                                                fontSize: ".7rem",
                                                                            }}
                                                                        >
                                                                            {template.reason}
                                                                        </p>
                                                                    }
                                                                    className="cursor-pointer"
                                                                >
                                                                    <InfoOutlinedIcon sx={{ opacity: "50%" }} />
                                                                </Tooltip>
                                                            )}
                                                        </StyledTableCell>
                                                        {/* // )} */}
                                                    </StyledTableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                // : !selectedBotId ? (
                                //     <Typography variant='h5' className='text-muted' alignItems={"center"} display={"flex"} justifyContent={"center"}>
                                //         Please select Reseller
                                //     </Typography>
                                // )
                                <NoRecords />
                            )}

                            {state.totalTemplatesCount > 0 && (
                                <Grid
                                    className="my-2"
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: 2,
                                    }}
                                >
                                    <Grid
                                        style={{
                                            marginTop: "15px",
                                            padding: 5,
                                        }}
                                    >
                                        Total Templates: {state.totalTemplatesCount}
                                    </Grid>
                                    {/* <TablePagination
                                        count={
                                            state.totalTemplatesCount
                                            /// rowsPerPage
                                        }
                                        component='div'
                                        variant='outlined'
                                        color='primary'
                                        page={currentPage}
                                        // onChange={handlePageChange}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={pageSize}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    /> */}

                                    <TablePaginationShowPage
                                        rowsPerPageOptions={[5, 10, 25, 100]}
                                        colSpan={3}
                                        count={state.totalTemplatesCount}
                                        rowsPerPage={pageSize}
                                        page={currentPage}
                                        slotProps={{
                                            select: {
                                                "aria-label": "Rows per page",
                                            },
                                            actions: {
                                                showFirstButton: true,
                                                showLastButton: true,
                                                slots: {
                                                    firstPageIcon: FirstPageRoundedIcon,
                                                    lastPageIcon: LastPageRoundedIcon,
                                                    nextPageIcon: ChevronRightRoundedIcon,
                                                    backPageIcon: ChevronLeftRoundedIcon,
                                                },
                                            },
                                        }}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </Grid>
                            )}
                        </CardContent>
                        {openFilter && (
                            <FilterAllTemplateModel
                                open={openFilter}
                                searchParams={searchParams}
                                handleClickOpenFilterModel={handleClickOpenFilterModel}
                                handleCloseFilterModel={handleCloseFilterModel}
                                setSearchParams={setSearchParams}
                                handleClickSearch={handleClickSearch}
                            />
                        )}
                        <AlertMessageComponent
                            message={state.controls.getAllTemplatesByPageSizeErrorMessage}
                            fieldName={"getAllTemplatesByPageSizeErrorMessage"}
                            handleClose={onCloseErrorMessage}
                            show={Boolean(state.controls.getAllTemplatesByPageSizeErrorMessage)}
                        />

                        <AlertMessageComponent
                            message={errorResponse}
                            fieldName={"getAllTemplatesByPageSizeErrorMessage"}
                            handleClose={() => setErrorResponse("")}
                            show={Boolean(errorResponse)}
                        />
                    </Card>
                </Grid>
            </Grid>
            {deleteTemplateModel && (
                <DeleteTemplateConformationModel
                    open={deleteTemplateModel}
                    setOpen={setDeleteTemplateModel}
                    templateData={templateData}
                    selectedBotDetails={state.selectedBotDetails}
                    setErrorResponse={setErrorResponse}
                    searchParams={searchParams}
                    setOperationStatus={setOperationStatus}
                />
            )}

            {testTemplate && (
                <TestTemplateModel
                    open={testTemplate}
                    setOpen={setTestTemplate}
                    templateData={templateData}
                    setErrorResponse={setErrorResponse}
                    searchParams={searchParams}
                    operationStatus={operationStatus}
                    setOperationStatus={setOperationStatus}
                    botDetails={templateBotDetails}
                />
            )}
            {operationStatus.success && (
                <SuccessMessageComponent
                    message={operationStatus.message}
                    fieldName={operationStatus.message}
                    handleClose={handleCloseSuccessMessage}
                    show={operationStatus.success}
                />
            )}
        </>
    );
};

export default ListTemplates;
